module.exports = __webpack_public_path__ + "img/key.4666dbbb.png";